import './App.css';
import Whatsapp from './Components/Whatsapp';

function App() {
  return (
    <div className="App">
      <Whatsapp />
    </div>
  );
}

export default App;
